function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Avatar, IconButton, MenuItem, Theme, Tooltip } from "@mui/material";
import { makeStyles, createStyles } from "@mui/styles";
import DoneIcon from "@mui/icons-material/Done";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";
import { marked, Renderer } from "marked";
import moment from "moment";
import { synthesizeSpeech } from "../../../components/aws/pollyClient";
import UserAvatar from "../../../components/mui/material/UserAvatar";
import { Clock } from "../../../components/Clock";
Renderer.prototype.paragraph = function (props) {
  return props.text + "\n";
};
var useStyles = makeStyles(function (theme) {
  return createStyles({
    messageRowLeft: {
      display: "flex",
      paddingLeft: "10px"
    },
    messageRowRight: {
      display: "flex",
      justifyContent: "flex-end",
      paddingRight: "10px"
    },
    messageGroupLeft: {
      position: "relative",
      marginLeft: "20px",
      marginRight: "20px",
      marginBottom: "10px",
      padding: "10px",
      backgroundColor: theme.palette.background.paper,
      textAlign: "left",
      font: "400 .9em 'Open Sans', sans-serif",
      border: "1px solid ".concat(theme.palette.background.paper),
      borderRadius: "6px",
      "&:after": {
        content: "''",
        position: "absolute",
        width: "0",
        height: "0",
        borderTop: "15px solid ".concat(theme.palette.background.paper),
        borderLeft: "15px solid transparent",
        borderRight: "15px solid transparent",
        top: "0",
        left: "-15px"
      },
      "&:before": {
        content: "''",
        position: "absolute",
        width: "0",
        height: "0",
        borderTop: "17px solid ".concat(theme.palette.background.paper),
        borderLeft: "16px solid transparent",
        borderRight: "16px solid transparent",
        top: "-1px",
        left: "-17px"
      }
    },
    messageLeft: {
      position: "relative",
      marginLeft: "20px",
      marginBottom: "10px",
      padding: "10px",
      whiteSpace: "pre-wrap",
      maxWidth: 800,
      backgroundColor: theme.palette.background.paper,
      textAlign: "left",
      font: "400 .9em 'Open Sans', sans-serif",
      border: "1px solid ".concat(theme.palette.background.paper),
      borderRadius: "6px",
      "&:after": {
        content: "''",
        position: "absolute",
        width: "0",
        height: "0",
        borderTop: "15px solid ".concat(theme.palette.background.paper),
        borderLeft: "15px solid transparent",
        borderRight: "15px solid transparent",
        top: "0",
        left: "-15px"
      },
      "&:before": {
        content: "''",
        position: "absolute",
        width: "0",
        height: "0",
        borderTop: "17px solid ".concat(theme.palette.background.paper),
        borderLeft: "16px solid transparent",
        borderRight: "16px solid transparent",
        top: "-1px",
        left: "-17px"
      }
    },
    messageRight: {
      position: "relative",
      marginRight: "20px",
      marginBottom: "10px",
      padding: "10px",
      whiteSpace: "pre-wrap",
      maxWidth: 800,
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      textAlign: "left",
      font: "400 .9em 'Open Sans', sans-serif",
      border: "1px solid ".concat(theme.palette.primary.main),
      borderRadius: "6px",
      "&:after": {
        content: "''",
        position: "absolute",
        width: "0",
        height: "0",
        borderTop: "15px solid ".concat(theme.palette.primary.main),
        borderLeft: "15px solid transparent",
        borderRight: "15px solid transparent",
        top: "0",
        right: "-15px"
      },
      "&:before": {
        content: "''",
        position: "absolute",
        width: "0",
        height: "0",
        borderTop: "17px solid ".concat(theme.palette.primary.main),
        borderLeft: "16px solid transparent",
        borderRight: "16px solid transparent",
        top: "-1px",
        right: "-17px"
      }
    },
    messageTooltip: {
      position: "absolute",
      color: "rgba(255,255,255,0.7)",
      top: 5,
      right: 10,
      fontSize: ".85em",
      fontWeight: 300
      // backgroundColor: "transparent",
    },
    messageTitle: {
      marginBottom: "10px",
      fontSize: 12.8,
      fontWeight: 600
    },
    messageBody: {
      display: "flex"
    },
    messageText: {},
    messageLabel: {
      display: "flex",
      alignItems: "end",
      marginBottom: "-5px",
      // color: "rgba(255,255,255,0.7)",
      fontSize: ".85em",
      fontWeight: 300
    },
    messageTimeStamp: {
      marginLeft: "10px"
    },
    messageStatus: {
      marginLeft: "5px",
      fontSize: "1rem"
    },
    avatar: {
      width: theme.spacing(4),
      height: theme.spacing(4)
    },
    avatarNothing: {
      color: "transparent",
      backgroundColor: "transparent",
      width: theme.spacing(4),
      height: theme.spacing(4)
    }
  });
});
export var MessageGroupLeft = function MessageGroupLeft(_ref) {
  var text = _ref.text,
    user = _ref.user,
    states = _ref.states,
    createdAt = _ref.createdAt;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    playing = _useState2[0],
    setPlaying = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    audio = _useState4[0],
    setAudio = _useState4[1];
  var classes = useStyles();

  // useEffect(() => {
  //   const viewedAt = states.find(
  //     (state) => state.user.id === authUserId
  //   ).viewedAt;

  //   !viewedAt && user.awsPollyVoiceId && togglePausePlay();
  // }, []);

  function togglePausePlay() {
    if (!audio) {
      synthesizeSpeech(text, user.awsPollyVoiceId, function (audioParam) {
        audioParam.addEventListener("ended", function () {
          setPlaying(false);
          audioParam.pause();
          audioParam.currentTime = 0;
        });
        setAudio(audioParam);
        setPlaying(true);
        audioParam.play();
      });
    } else if (audio.paused) {
      setPlaying(true);
      audio.play();
    } else {
      setPlaying(false);
      audio.pause();
    }
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.messageRowLeft
  }, /*#__PURE__*/React.createElement(UserAvatar, {
    alt: user.fullname,
    className: classes.avatar,
    user: user
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: classes.messageGroupLeft
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.messageTitle
  }, user.fullName), /*#__PURE__*/React.createElement("div", {
    className: classes.messageBody
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.messageText,
    dangerouslySetInnerHTML: {
      __html: marked.parse(text)
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.messageLabel
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.messageTimeStamp
  }, moment(createdAt).format("hh:mm a"))))))), user.awsPollyVoiceId && /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center"
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: togglePausePlay,
    sx: {
      ml: 0.5,
      bgcolor: "background.default"
    }
  }, playing ? /*#__PURE__*/React.createElement(PauseIcon, null) : /*#__PURE__*/React.createElement(PlayArrowIcon, null))));
};
export var MessageLeft = function MessageLeft(_ref2) {
  var text = _ref2.text,
    user = _ref2.user,
    states = _ref2.states,
    createdAt = _ref2.createdAt;
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    playing = _useState6[0],
    setPlaying = _useState6[1];
  var _useState7 = useState(),
    _useState8 = _slicedToArray(_useState7, 2),
    audio = _useState8[0],
    setAudio = _useState8[1];
  var classes = useStyles();

  // useEffect(() => {
  //   const viewedAt = states.find(
  //     (state) => state.user.id === authUserId
  //   ).viewedAt;

  //   !viewedAt && user.awsPollyVoiceId && togglePausePlay();
  // }, []);

  function togglePausePlay() {
    if (!audio) {
      synthesizeSpeech(text, user.awsPollyVoiceId, function (audioParam) {
        audioParam.addEventListener("ended", function () {
          setPlaying(false);
          audioParam.pause();
          audioParam.currentTime = 0;
        });
        setAudio(audioParam);
        setPlaying(true);
        audioParam.play();
      });
    } else if (audio.paused) {
      setPlaying(true);
      audio.play();
    } else {
      setPlaying(false);
      audio.pause();
    }
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.messageRowLeft
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.messageLeft
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.messageBody
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.messageText,
    dangerouslySetInnerHTML: {
      __html: marked.parse(text)
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.messageLabel
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.messageTimeStamp
  }, moment(createdAt).format("hh:mm a")))))), user.awsPollyVoiceId && /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center"
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: togglePausePlay,
    sx: {
      ml: 0.5,
      bgcolor: "background.default"
    }
  }, playing ? /*#__PURE__*/React.createElement(PauseIcon, null) : /*#__PURE__*/React.createElement(PlayArrowIcon, null))));
};
export var MessageRight = function MessageRight(_ref3) {
  var text = _ref3.text,
    group = _ref3.group,
    id = _ref3.id,
    createdAt = _ref3.createdAt;
  var states = useSelector(function (state) {
    return state.entities.messages.byGroupId[group.id].find(function (message) {
      return message.id === id;
    }).states;
  });
  var viewed = states.every(function (state) {
    return state.viewedAt;
  });
  var classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.messageRowRight
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.messageRight
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.messageBody
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.messageText,
    dangerouslySetInnerHTML: {
      __html: marked.parse(text)
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.messageLabel
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.messageTimeStamp
  }, moment(createdAt).format("hh:mm a")), viewed ? /*#__PURE__*/React.createElement(DoneAllIcon, {
    className: classes.messageStatus
  }) : /*#__PURE__*/React.createElement(DoneIcon, {
    className: classes.messageStatus
  })))));
};